type TBodyForNotificationIncomingMessage = {
    conversationId: string;
    channel: string;
};

export const formattedBodyForNotificationIncomingMessage = ({
    conversationId,
    channel,
}: TBodyForNotificationIncomingMessage) => {
    return {
        type: 'conversation',
        message: `Messages.NewMessage`,
        conversation: conversationId,
        _id: conversationId,
        createdAt: Date.now(),
    };
};
